export default "__VITE_ASSET__BALu36n0__"